import { cn } from "@/lib/utils";
import PrimaryButton from "@/components/ui/primary-button";
import { Info, X } from "react-feather";

export interface ModalProps {
  className?: string;
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description: string;
}
const Modal: React.FC<ModalProps> = ({
  className,
  isOpen,
  onClose,
  title,
  description,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className={cn(
        "mx-auto w-full rounded-xl bg-white sm:w-[326px] md:w-[467px] lg:w-[511px] lg:rounded-2xl",
        "overflow-hidden",
        "shadow-[2px_8px_20px_0px_#312E2C33]",
        className
      )}
    >
      <div className="relative flex flex-row gap-2 bg-neutral-100 p-2 md:gap-3 md:p-3 lg:gap-4 lg:p-4">
        <Info
          size={32}
          className="mt-[2px] h-[20px] w-[20px] text-primary-500 lg:h-[26px] lg:w-[26px]"
        />
        <span className="w-full pr-5 font-montserrat text-subheading-3-500 text-neutral-600 lg:text-heading-4">
          {title}
        </span>
        <X
          onClick={onClose}
          size={16}
          className="absolute right-2 top-2 h-[16px] w-[16px] text-neutral-600"
        />
      </div>
      <div className="p-2 font-roboto text-body-1-300 text-neutral-600 md:p-3 lg:p-4">
        {description}
      </div>
      <div className="flex justify-end gap-2 border-t border-neutral-200 p-2 md:gap-3 md:p-3">
        <PrimaryButton
          color="teal"
          href="/contact-us"
        >
          React Out to Us
        </PrimaryButton>
      </div>
    </div>
  );
};

export default Modal;
